<script lang="ts" setup>
import { inject } from 'vue'
import { ListboxOption } from '@headlessui/vue'
import LineCheck from '../../icons/LineCheck.vue'
import { DTFieldSelectProvider } from '../../keys'
import type { FieldSelectProvider } from '../../types/field'
import type { DTSelectOption } from './types'

const props = defineProps<{
  text?: string
  value: DTSelectOption['value']
}>()

const selectProvider = inject<FieldSelectProvider>(DTFieldSelectProvider)
selectProvider?.registerOption({ value: props.value, text: props?.text ?? '' })
</script>

<template>
  <ListboxOption
    v-slot="{ active, selected }"
    :value="value"
    @click.stop
  >
    <div
      class="flex cursor-pointer select-none items-center gap-2 p-3 leading-6 text-gray-600"
      :class="{ 'bg-gray-50': active }"
    >
      <div class="flex flex-1 items-center gap-2">
        <slot
          :option="{ value, text }"
          :active="active"
          :selected="selected"
        >
          <span class="truncate">{{ text }}</span>
        </slot>
      </div>
      <LineCheck
        v-if="selected"
        class="w-4 shrink-0"
        aria-hidden="true"
      />
    </div>
  </ListboxOption>
</template>
